module.exports = __webpack_public_path__ + "img/rugbyLes.51fe700c.jpg";